const useVideoTrack = videoTrack => {
  return {
    videoTrack,
    isEnabled: !!videoTrack,
  };
};

export default useVideoTrack;
